import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPlayFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.971 3.81c-1.83-1.16-4.221.156-4.221 2.323v11.732c0 2.168 2.39 3.483 4.221 2.324l9.262-5.866c1.705-1.08 1.705-3.567 0-4.647z"
  }));
}
var IcPlayFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPlayFill));

export { IcPlayFill as I };
